import AuthStore from '@/store/modules/Auth'

const store = {
    state: {
        loading: false,
        error: false,
        message: false
    },
    mutations: {
        LOADING: (state, value) => {
            state.loading = value
        },
        ERROR: (state, value) => {
            state.error = value
        },
        MESSAGE: (state, value) => {
            state.message = value
        }
    },
    getters: {
        getLoading: (state) => {
            return state.loading
        },
        getError: (state) => {
            return state.error
        },
        getMessage: (state) => {
            return state.message
        }
    },
    modules: {
        auth: AuthStore
    }
}

export default new Vuex.Store(store)
